import { useI18n } from 'vue-i18n'
import columnStore from '@/stores/column'

export default function useModuleColumns(component: string) {
	const i18n = useI18n()
	const cols = columnStore()

	const description = cols.define(component, 'description', i18n.t('description'), true)
	const code = cols.define(component, 'name', i18n.t('code'), true)
	const type = cols.define(component, 'type', i18n.t('module.type'), true)
	const active = cols.define(component, 'active', i18n.t('active'), true)
	const stats = cols.define(component, 'stats', i18n.t('module.stats'), true)
	const responsible = cols.define(component, 'responsible', i18n.t('responsible'), true)
	const instance = cols.define(component, 'instance_id', i18n.t('instance'), true)
	const version = cols.define(component, 'version', i18n.t('version'), true)

	const columns = { description, code, responsible, instance, version, active, stats, type }

	const { custom, all } = cols.finalize(component, columns)

	return { columns, custom, all }
}
